// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__14k_v","svg_container":"svg_svg_container__1Vakn","curve1":"svg_curve1__2uxeZ","curve2":"svg_curve2__30mmD","mtt":"svg_mtt__1RWxn"};